// User Badge Management Actions
export const USER_BADGE_ACTION_STARTS = 'USER_BADGE_ACTION_STARTS';
export const USER_BADGE_ACTION_ERRORS = 'USER_BADGE_ACTION_ERRORS';

// Get user badges
export const GET_USER_BADGES = 'GET_USER_BADGES';

// Create, Update, Delete user badges
export const ASSIGN_BADGE_TO_USER = 'ASSIGN_BADGE_TO_USER';
export const UPDATE_USER_BADGE = 'UPDATE_USER_BADGE';
export const DELETE_USER_BADGE = 'DELETE_USER_BADGE';

// Action creators
export const userBadgeActionStarts = () => ({
  type: USER_BADGE_ACTION_STARTS,
});

export const userBadgeActionErrors = (error: string) => ({
  type: USER_BADGE_ACTION_ERRORS,
  payload: error,
});

export const getUserBadgesAction = (userBadges: any[]) => ({
  type: GET_USER_BADGES,
  payload: userBadges,
});

export const assignBadgeToUserAction = (userBadge: any) => ({
  type: ASSIGN_BADGE_TO_USER,
  payload: userBadge,
});

export const updateUserBadgeAction = (userBadge: any) => ({
  type: UPDATE_USER_BADGE,
  payload: userBadge,
});

export const deleteUserBadgeAction = (userBadgeId: string) => ({
  type: DELETE_USER_BADGE,
  payload: userBadgeId,
});
